export const BrandDefaultValue: IBrand["get"] = {
    id: 0,
    faName: "",
    enName: "",
    url: "",
    logo: "",
    order: null,
    description: "",
    seoDescription: "",
    seoKeywords: "",
    updateDateTime: "",
    createDateTime: "",
};
